import axios from "axios";
import { installApiLogger } from "./apiLog";
import { getLang } from "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 60_000, // 60s — long enough for big PDF uploads, short enough to surface a clear error if a request is genuinely stuck.
});

// In-memory bearer token (no localStorage — XSS-safe). Session persistence
// across reloads comes from the httpOnly "access_token" cookie set by the
// backend on login/register; this header is a same-tab convenience fallback.
let authToken = null;
export const setAuthToken = (token) => { authToken = token || null; };

api.interceptors.request.use((config) => {
  if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" && iso.length === 10 ? new Date(iso + "T00:00:00") : new Date(iso);
    const loc = getLang() === "es" ? "es" : "en-US";
    return d.toLocaleDateString(loc, { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    if (typeof iso === "string" && iso.length === 10) return fmtDate(iso);
    const d = new Date(iso);
    const loc = getLang() === "es" ? "es" : "en-US";
    return `${d.toLocaleDateString(loc, { year: "numeric", month: "short", day: "2-digit" })}, ${d.toLocaleTimeString(loc, { hour: "numeric", minute: "2-digit" })}`;
  } catch {
    return iso;
  }
};

// Feedback tracker: rolling log of API calls for bug reports.
installApiLogger(api);
